import React from 'react'

import grieche2 from "./grieche 2.png"
import bauplan from "./bauplan neu.png"
import indexierung from "./indexierung.png"
import awmf_suche from "./awmf_suche.png"
import web_scraping from "./web-scraping-with-python.png"
import klassifikationen from "./klassifikationen.png"
import auswertung from "./postpartale depression.png"
import ref_list from "./ref_list.png"

const button_style = {
    backgroundColor: "gold",
    padding: "25px",
    borderRadius: "10px",
}
const site_style = {
    backgroundColor: "ivory"
}
const p_tag = {
    marginLeft: "5px",
    marginRight: "5px"
}

const skill_icon = {
    backgroundColor: "lightgrey",
    borderRadius:"10px",
    textAlign: "center",
    padding: "15px",
    margin:"5px",
    marginTop: "15px"

}

const container_style = {
    border: "2px solid grey",
    borderRadius:"10px", 
    backgroundColor:"ivory"
}

const about = () => {
    return (
        <div>
            <Projekte_Webseite_2/>
        </div>
    )
}


function Projekte_Webseite_2(){
    return(
        <div>
            <div class="container">
                <h2 style={{color:"white"}}>Projekte</h2>
                <p style={{color:"lightgrey"}}>
                    In diesem Abschnitt des Portfolios möchte ich meine Bachelorarbeit vorstellen. 
                    Sowohl die Problem-und Zielstellung sowie auch die Implementierung im Zuge der 
                    Bachelorarbeit werde ich hierbei vorstellen. 
                    Neben diesen Schritten wurde auch eine Evaluation in 2 Teilen durchgeführt, 
                    welche ebenfalls noch präsentiert wird. 
                    In Zusammenarbeit mit der Arbeitsgemeinschaft der Wissenschaftlichen 
                    Medizinischen Fachgesellschaften e. V. (AWMF) wurde das Thema für die Bachelorarbeit gefunden 
                    und anschließend die Problemstellung/Zielstellung erforscht. </p>
                <div class="row">
                    <div class="col-sm-6">
                        <a href="https://www.awmf.org/">
                        <img style={container_style} class="rounded float-start img-fluid" src={awmf_suche}/>
                        </a>
                    </div>
                    <div class="col-sm-6" style={{color:"darkgrey"}}>
                    <h2 >Problemstellung</h2>
                        <p>Die AWMF bietet auf ihrer Webseite ein klinisches Leitlinienregister zur freien Verfügung,
                             sodass Ärzte, Patienten und weitere Personen aus dem medizinischen Bereich 
                             darauf zugreifen können. Zum damaligen Zeitpunkt war die Suchfunktion, 
                             welche für dieses Leitlinienregister genutzt wurde, nicht sonderlich gewinnbringend 
                             und lieferte für einen bestimmten Suchbegriff, nicht die gewünschten Ergebnisse. 
                             Es wurden Leitlinien ausgegeben, die den Suchbegriff zwar enthielten, 
                             aber nicht relevant für die Suche waren. </p>
                    </div>
                </div>
                <hr style={{color:"lightgrey"}}/>
            </div>

            <div class="container">
                <div class="row">
                    <div class="col-sm-6" style={{color:"darkgrey"}}>
                        <h2 >Zielstellung</h2>
                        <p> Durch die Nutzung einer Suchmaschine wie Elasticsearch sollte eine Datenbank erstellt werden,
                             in der die Suche nach dem jeweiligen Suchbegriff schnell erfolgt und 
                             die Nutzung von Synonymen erleichtert genutzt werden kann. 
                             In der dargestellten Abbildung ist ein Bauplan für dieses System dargestellt. </p>  
                    </div>
                    <div class="col-sm-6" >
                        <a href='#'>
                        <img style={container_style} class="rounded float-start img-fluid" src={bauplan}/>
                        </a>
                    </div>
                </div>
                <hr style={{color:"lightgrey"}}/>
            </div>

            <div class="container">
                <div class="row">
                    <div class="col-sm-6">
                        <a href="https://www.crummy.com/software/BeautifulSoup/bs4/doc/">
                        <img style={container_style} class="rounded float-start img-fluid" src={web_scraping}/>
                        </a>
                    </div>
                    <div class="col-sm-6" style={{color:"darkgrey"}}>
                    <h2 >Web Scraping</h2>
                        <p> 
                            Um an die Gesamtheit der Leitlinien zu kommen, 
                            habe ich einen Web Scraper erstellt und damit alle Leitlinien 
                            für die spätere Indexierung heruntergladen. 
                            Hier wurden die üblichen Bibliotheken wie Requests und Beautiful Soup genutzt.

                        </p>
                    </div>
                </div>
                <hr style={{color:"lightgrey"}}/>
            </div>

            <div class="container">
                <div class="row">
                    <div class="col-sm-6" style={{color:"darkgrey"}}>
                        <h2 >Indexierung</h2>
                        <p> Die Erstellung des Programms für die Suchfunktion erfolgte mittels Python 
                            in Kombination mit Elasticsearch. 
                            Die zuvor mit dem Web Scraper geholten Dokumente wurde anschließend an Elasticsearch 
                            übergeben und indexiert. 
                            Nachdem alle Leitlinien indexiert wurde, war eine schnelle und 
                            detaillierte Suche möglich.  </p>  
                    </div>
                    <div class="col-sm-6" >
                        <a href='https://www.elastic.co/de/elasticsearch/'>
                        <img style={container_style} class="rounded float-start img-fluid" src={indexierung}/>
                        </a>
                    </div>
                </div>
                <hr style={{color:"lightgrey"}}/>
            </div>
            
            <div class="container">
                <div class="row">
                    <div class="col-sm-6">
                        <a href="https://www.dimdi.de/dynamic/de/klassifikationen/icd/icd-10-gm/">
                        <img style={container_style} class="rounded float-start img-fluid" src={klassifikationen}/>
                        </a>
                    </div>
                    <div class="col-sm-6" style={{color:"darkgrey"}}>
                    <h2 >Klassifikationen und Terminologien</h2>
                        <p> 
                            Damit die Suche nach Leitlinien noch detaillierter erfolgen konnte, 
                            wurden Klassifikationen und Terminologien eingeführt, wie ICD-10, OPS und LOINC.
                            Hierbei wurden die Codes und Beschreibung für die jeweilige Krankheit, Operation 
                            oder Laboranalyse genutzt, um die Suche zu erweitern. 
                            Für einen entsprechenden Suchbegriff wurde einerseits Elasticsearch im einzelnen verwendet und 
                            anschließend die Erweiterung mit den Synonymen, wobei ein Synonym wie folgt definiert wurde: 
                            Wörter aus den Klassifikationen und Terminologien, die den Suchbegriff enthalten und alle Wörter, 
                            die unter dem gleichen Code in der Klassifikation zu finden sind.

                        </p>
                    </div>
                </div>
                <hr style={{color:"lightgrey"}}/>
            </div>

            <div class="container">
                <div class="row">
                    <div class="col-sm-6" style={{color:"darkgrey"}}>
                        <h2 >Evaluation</h2>
                        <p> Die Evaluation erfolgte in zwei Teilen. 
                            Zum einen wurde die Suche nach themenverwandten Leitilinien bewertet 
                            und zum anderen erfolgte die Bewertung durch die Nutzenden, 
                            also die Mitarbeiter der AWMF. 
                            <h4 style={{marginTop:"5px"}}>Bewertung der Suche durch die Nutzenden</h4>
                            In der Abbildung wurde die Bewertung durch 
                            die Nutzenden am Beispiel des Suchbegriffes <strong>Postpartale Depression</strong> dargestellt. Dabei erhielten die Nutzenden eine Aufreihung 
                            von Ergebnislisten für den dargestellten Suchbegriff und sollten die jeweils beste Liste auswählen. 
                            Welches System für die jeweilige Liste verwendet wurde, sollte dabei nicht ersichtlich sein, 
                            damit die Nutzenden in ihrer entscheidung nicht beeinflusst werden. Die Listen verwenden dabei entweder nur Elasticsearch oder eine der drei Klassifikationen in Kombination mit Elasticsearch oder die Kombination von allen drei Klassifkationen. </p>  
                    </div>
                    <div class="col-sm-6" >
                        <a href='#'>
                        <img style={container_style} class="rounded float-start img-fluid" src={auswertung}/>
                        </a>
                    </div>
                </div>
                <hr style={{color:"lightgrey"}}/>
            </div>

            <div class="container">
                <div class="row">
                    <div class="col-sm-6">
                        <a href="#">
                        <img style={container_style} class="rounded float-start img-fluid" src={ref_list}/>
                        </a>
                    </div>
                    <div class="col-sm-6" style={{color:"darkgrey"}}>
                    <h2 >Bewertung der Suche nach themenverwandten Leitilinien</h2>
                        <p> 
                            Um diesen Teil der Bewertung durchzuführen, waren die themenverwandten Leitlinien der jeweiligen Leitlinie notwendig. 
                            Die AWMF-Mitarbeiter haben für bestimmte Leitlinien eine Liste von themenvwandten Leitlinien erstellt 
                            und diese Liste wurde hierbei als Referenzliste genutzt. Es wurde anhand des Recalls ermittelt, 
                            wie viele der Leitlinien aus der Ergebnisliste in der entsrechenden Refernezliste enthalten sind.
                            In der Abbiludng ist ein Beispiel für eine Leitlinie und die entsprechende Referenzliste dargestellt.
                        </p>
                    </div>
                </div>
                <hr style={{color:"lightgrey"}}/>
            </div>

        </div>
    )
}


export default about